const BASE = process.env.REACT_APP_BACKEND_URL;

export const giveawayHeaders = (admin = false) => admin
  ? { 'X-Admin-Key': localStorage.getItem('advecti_admin_key') || '' }
  : { Authorization: `Bearer ${localStorage.getItem('advecti_token') || ''}` };

export const giveawayApi = async (path, options = {}) => {
  const response = await fetch(`${BASE}/api${path}`, { credentials: 'include', ...options });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(typeof data.detail === 'string' ? data.detail : 'Please check your details and try again.');
  }
  return data;
};

export const privateGiveawayApi = (path, admin, options = {}) => giveawayApi(
  `/${admin ? 'admin' : 'advertiser'}/giveaways${path}`,
  { ...options, headers: { ...giveawayHeaders(admin), 'Content-Type': 'application/json' } },
);

export const giveawayDownload = async (path, admin, filename) => {
  const response = await fetch(`${BASE}/api/${admin ? 'admin' : 'advertiser'}/giveaways${path}`, {
    headers: giveawayHeaders(admin),
  });
  if (!response.ok) throw new Error('Could not export entries. Please try again.');
  const url = URL.createObjectURL(await response.blob());
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
};

export const uploadGiveawayLogo = (file, admin) => {
  const form = new FormData();
  form.append('file', file);
  return giveawayApi(`/${admin ? 'admin' : 'advertiser'}/giveaways/logo-uploads`, {
    method: 'POST', headers: giveawayHeaders(admin), body: form,
  });
};